import cx from 'classnames';
import { createUseHtmlId } from '../../hooks/useHtmlId';
import { renderDesignTokens, useDesignTokens } from '../../theme';
import { postfixTestId } from '../../util/testId';
import { BusyStateIndicator } from '../BusyStateIndicator';
import { Flow } from '../Layouts/Flow';
import { Toolbar } from '../Toolbar';
import { BaseDialog } from './__internal__';
import cn from './FullScreenDialog.css.json';
import './FullScreenDialog.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useHeaderId = createUseHtmlId('fullScreenDialog-header');
export const FullScreenDialog = props => {
  const dialogHeaderId = useHeaderId();
  const role = props.role ?? 'dialog';
  const dt = useDesignTokens();
  const tokens = {
    ...getFullScreenDialogDesignTokens(dt),
    ...props.theme?.(dt)
  };
  const renderFullScreenDialog = () => {
    return /*#__PURE__*/_jsx("div", {
      className: cx(cn.container, props.className),
      style: tokens,
      role: role,
      "aria-labelledby": dialogHeaderId,
      "aria-describedby": props.ariaDescribedBy,
      onKeyDown: props.onKeyDown,
      children: /*#__PURE__*/_jsxs(BusyStateIndicator, {
        ...props.busyStateIndicatorProps,
        fillParentContainer: true,
        containerClassName: cn.containerInner,
        children: [/*#__PURE__*/_jsxs(Flow, {
          orientation: "vertical",
          spacing: "xs",
          className: cn.heading,
          children: [props.breadCrumbs && props.breadCrumbs.length > 0 && /*#__PURE__*/_jsx(Toolbar, {
            testId: postfixTestId(props.testId, '-breadcrumToolbar'),
            items: [{
              type: 'Breadcrumb',
              orientation: 'HORIZONTAL',
              values: props.breadCrumbs,
              selectCrumb: props.onSelectBreadCrumbItem
            }, {
              type: 'ToolbarSpacer'
            }]
          }), /*#__PURE__*/_jsx("div", {
            className: cn.header,
            children: props.renderHeaderToolbar(dialogHeaderId, props.breadCrumbs && props.breadCrumbs[props.breadCrumbs?.length - 1].values[0])
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: cn.contentArea,
          children: props.children
        })]
      })
    });
  };
  return props.isOpen ? /*#__PURE__*/_jsx(BaseDialog, {
    title: "",
    isOpen: props.isOpen,
    renderLayout: renderFullScreenDialog,
    focusLockProps: props.focusLockProps
  }) : null;
};
export const getFullScreenDialogDesignTokens = dt => {
  return {
    ...renderDesignTokens({
      'spacing-m': dt.tokens['space-base-m'],
      'spacing-xl': dt.tokens['space-base-xl'],
      'title-font-size-xl': dt.tokens['font-size-heading-text-xxxl'],
      'title-font-weight': dt.tokens['font-style-weight-700'],
      'title-fg': dt.tokens['color-heading-text'],
      bg: dt.tokens['color-container-background-2'],
      'content-bg': dt.tokens['color-container-background-0'],
      'content-bd': dt.tokens['color-container-border-4']
    }, 'full-screen-dialog'),
    ...(!dt.enableNovaTokens && getFullScreenLegacyDialogDesignTokens(dt))
  };
};
export const getFullScreenLegacyDialogDesignTokens = dt => {
  let themeVariant = {};
  switch (dt.themeVariant) {
    case 'dark':
      themeVariant = {
        bg: dt.c.p_2,
        'content-bg': dt.c.p_3,
        'content-bd': dt.c.n_2
      };
      break;
    case 'high-contrast':
      themeVariant = {
        bg: dt.c.black,
        'content-bg': dt.c.black,
        'content-bd': dt.c.n2
      };
      break;
    default:
      themeVariant = {
        bg: dt.c.n3,
        'content-bg': dt.c.white,
        'content-bd': dt.c.n2
      };
  }
  return {
    ...renderDesignTokens({
      'title-font-size-xl': dt.reportTokens.font.size.xl,
      'title-font-weight': dt.reportTokens.font.weight.thick,
      'title-fg': dt.themeVariant === 'light' ? dt.c.black : dt.c.white,
      ...themeVariant
    }, 'full-screen-dialog')
  };
};
//# sourceMappingURL=FullScreenDialog.js.map